<ng-container *ngIf="paciente; else buscaPaciente">
  <!-- Cabeçalho do paciente no padrão do Abrir Atendimento: nome, código e a etiqueta do plano. -->
  <div class="pac-escolhido" [class.compacto]="!detalhes">
    <div class="topo">
      <span class="avatar" aria-hidden="true">{{ (paciente.nome || '?').trim().charAt(0) }}</span>
      <div class="info">
        <b>{{ paciente.nome }}</b>
        <span>Cód. {{ paciente.cdPessoaFisica }} · {{ formatarCpf(paciente.cpf) || 'Sem CPF' }}</span>
      </div>
      <button type="button" class="btn btn-contorno btn-sm" (click)="trocar()" [disabled]="bloqueado">Trocar</button>
    </div>
    <div class="selos">
      <span class="selo cinza" *ngIf="carregandoPlano">Consultando plano...</span>
      <ng-container *ngIf="!carregandoPlano">
        <span class="selo ok" *ngIf="plano?.temPlano">{{ plano?.dsCategoria || 'Plano do cartão' }} ativo</span>
        <span class="selo cinza" *ngIf="!plano?.temPlano">{{ plano ? 'Particular · sem plano do cartão' : 'Plano não consultado' }}</span>
      </ng-container>
      <span class="selo info" *ngIf="detalhes && saldo > 0">Saldo {{ formatarBrl(saldo) }}</span>
    </div>
  </div>

  <div class="bloco-hist" *ngIf="detalhes">
    <span class="rot">Últimos agendamentos</span>
    <div class="hist">
      <div class="hist-l" *ngIf="carregandoHistorico"><span class="sub2">Carregando...</span></div>
      <div class="hist-l" *ngIf="!carregandoHistorico && erroHistorico"><span class="sub2">Não foi possível carregar o histórico.</span></div>
      <div class="hist-l" *ngIf="!carregandoHistorico && !erroHistorico && !historico.length">
        <span class="sub2">Nenhum agendamento nos últimos {{ mesesHistorico }} meses.</span>
      </div>
      <div class="hist-l" *ngFor="let h of linhasHistorico" [class.futuro]="h.chip === 'futuro'">
        <span class="d">{{ h.diaMes }} {{ h.hora }}</span>
        <span class="oque" [title]="h.titulo">
          {{ h.titulo }}
          <small><span class="chip-h" [ngClass]="'c-' + h.chip">{{ h.chipTexto }}</span>{{ h.sub }}</small>
        </span>
        <span class="st-h" [ngClass]="h.corStatus">{{ h.status }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #buscaPaciente>
  <div class="campo">
    <div class="busca">
      <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
      <input
        type="search"
        aria-label="Buscar paciente"
        placeholder="Nome ou CPF (mínimo 3 caracteres)"
        autocomplete="off"
        [disabled]="bloqueado"
        [(ngModel)]="busca"
        (ngModelChange)="aoDigitar()"
      />
    </div>
  </div>
  <p class="dica" *ngIf="busca.trim().length < 3">Digite ao menos 3 letras ou números.</p>
  <p class="dica" *ngIf="buscando">Buscando...</p>
  <p class="dica" *ngIf="!buscando && buscou && !resultados.length">
    Nenhum paciente encontrado. O cadastro de paciente novo é feito no Abrir Atendimento da Fila.
  </p>
  <div class="resultados" *ngIf="resultados.length">
    <button type="button" class="pac-card" *ngFor="let p of resultados" (click)="escolher(p)">
      <b>{{ p.nmPessoaFisica }}</b>
      <span>{{ formatarCpf(p.nrCpf) || 'Sem CPF' }}</span>
    </button>
  </div>
</ng-template>
